import React from 'react';

const FilterIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="8" fill="#E4D6F5" />
            <g clipPath="url(#clip0_4589_31241)">
                <path d="M34.6943 35.1063V29.7871" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M31.6328 29.7871H37.7553" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18.3682 35.107V27.6602" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.3066 27.6602H21.4291" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M26.5312 35.1057V25.5312" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.4697 21.2754H29.5922" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34.6943 25.5315V15.957" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M26.5312 21.2762V15.957" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18.3682 23.4038V15.957" stroke="#425B76" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4589_31241">
                    <rect width="24.4898" height="25.5319" fill="white" transform="translate(14.2861 12.7656)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default FilterIcon;